module.exports = __webpack_public_path__ + "img/airpa_13.0b47a692.svg";